import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Disable16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99998 0.951843C6.1307 0.951843 4.33798 1.69441 3.0162 3.0162C1.69441 4.33798 0.951843 6.1307 0.951843 7.99998C0.951843 9.8667 1.69237 11.6571 3.01075 12.9783C3.01255 12.9802 3.01436 12.982 3.01618 12.9838C3.01801 12.9856 3.01984 12.9875 3.02168 12.9893C4.34294 14.3076 6.13329 15.0481 7.99998 15.0481C9.86927 15.0481 11.662 14.3056 12.9838 12.9838C14.3056 11.662 15.0481 9.86927 15.0481 7.99998C15.0481 6.13329 14.3076 4.34294 12.9893 3.02168C12.9875 3.01984 12.9856 3.01801 12.9838 3.01618C12.982 3.01436 12.9802 3.01255 12.9783 3.01075C11.6571 1.69237 9.8667 0.951843 7.99998 0.951843ZM11.5235 3.52186C10.5243 2.73555 9.28448 2.30184 7.99998 2.30184C6.48874 2.30184 5.0394 2.90218 3.97079 3.97079C2.90218 5.0394 2.30184 6.48874 2.30184 7.99998C2.30184 9.28448 2.73555 10.5243 3.52186 11.5235L11.5235 3.52186ZM4.47646 12.4781C5.47574 13.2644 6.7155 13.6981 7.99998 13.6981C9.51122 13.6981 10.9606 13.0978 12.0292 12.0292C13.0978 10.9606 13.6981 9.51122 13.6981 7.99998C13.6981 6.7155 13.2644 5.47574 12.4781 4.47646L4.47646 12.4781Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
